import React from 'react';
import '../../App.css'
import Button from 'react-bootstrap/esm/Button';
import Modal from 'react-bootstrap/Modal';
import { useForm } from "react-hook-form";
import Form from 'react-bootstrap/Form';
import { TableType } from '../../TableConstants';
import Card from '../Card/Card'

function DeleteModal({itemType, showModal, handleCloseModal, deleteItem, itemToDelete, showAlert, alertData }){
    const { register, handleSubmit } = useForm();

    return (
        <Modal show={showModal}>
            <Form onSubmit={handleSubmit(deleteItem)}>
                <Modal.Header>
                    <Modal.Title>Confirm Deletion of {itemToDelete.FlagName ?? itemToDelete.ConfigurationName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {itemType === TableType.FeatureFlag?
                    <section>
                        <Form.Group>
                            <Form.Label>FlagName</Form.Label>
                            <Form.Control type='text' name="flagName" readOnly value={itemToDelete.FlagName} {...register('flagName')} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>ServiceName</Form.Label>
                            <Form.Control type='text' name="serviceName" readOnly value={itemToDelete.ServiceName} {...register('serviceName')} />
                        </Form.Group> 
                    </section>
                    :
                    <section>
                        <Form.Group>
                            <Form.Label>ConfigurationName</Form.Label>
                            <Form.Control type='text' name="configName" readOnly value={itemToDelete.ConfigurationName} {...register('configName')} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>ProductName</Form.Label>
                            <Form.Control type='text' name="productName" readOnly value={itemToDelete.ProductName} {...register('productName')} />
                        </Form.Group>  
                    </section>
                    }
                        <Form.Group>
                            <Form.Label>Username</Form.Label>
                            <Form.Control type='text' name="username" {...register('username')} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Password</Form.Label>
                            <Form.Control type='password' name="password" {...register('password')} />
                        </Form.Group>
                        <section style={{padding:10}}>
                        <Card show={showAlert} variant={alertData.variant} heading={alertData.heading} message={alertData.message}></Card>
                        </section>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Cancel</Button>
                    <Button variant="danger" type="submit">Delete</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}
export default DeleteModal;